import { Grid, Icon, IconButton, Spinner, Table } from '@prometheus/components';
import { BundleTile } from '../BundleTile/BundleTile';
import { Status } from '@prometheus/types';
import { getVocabularyBundlesList } from '@/api/vocabulary-management';
import { useInterval, useList } from '@prometheus/hooks';
import { FC } from 'react';

export const Bundles: FC = () => {
  const {
    rawData,
    status,
    getEntityList,
    totalElements,
    pageCount,
    pageNumber,
    pageSize,
  } = useList({
    methods: {
      read: { method: getVocabularyBundlesList },
    },
    autoLoad: true,
  });

  useInterval(() => {
    if (
      status !== Status.INITIAL &&
      status !== Status.IN_PROGRESS &&
      status !== Status.IN_PROGRESS_RELOAD
    ) {
      getEntityList({ pageNumber, pageSize });
    }
  }, 15000);

  return (
    <Grid
      item
      xs={12}
      sx={{
        '.table-actions': { padding: '10px 0' },
        '.c-table > div > div': {
          padding: 0,
        },
        '.pagination-button': {
          backgroundColor: '#fff',
          '&.active': {
            backgroundColor: 'secondary.main',
            fontWeight: 'bold',
            color: '#fff',
          },
        },
      }}
    >
      <Grid item xs={12} textAlign="right" mt={-1} mb={0.5}>
        <IconButton
          onClick={() => getEntityList({ pageNumber, pageSize })}
          size="small"
          sx={{ fontSize: 16 }}
        >
          {status === Status.IN_PROGRESS ||
          status === Status.IN_PROGRESS_RELOAD ? (
            <Spinner size={16} />
          ) : (
            <Icon iconName="reload" sx={{ fontSize: 16 }} />
          )}
        </IconButton>
      </Grid>
      <Table
        columns={[{ Header: '', id: 'id' }]}
        data={rawData}
        tileComponent={props => (
          <BundleTile {...props} onReload={getEntityList} />
        )}
        isLoading={status === Status.IN_PROGRESS}
        enablePagination
        totalElements={totalElements || rawData?.length}
        // pageCount={pageCount}
        // pageNumber={pageNumber}
        pageSize={pageSize}
      />
    </Grid>
  );
};
